import React from 'react'

const education = [
  {
    degree: 'B.E in Information Technology',
    institution: 'Matoshri College of Enginnering & Research Centre, Nashik',
    period: 'Aug 2023 — Present',
    detail: 'CGPA: 9.09/10',
  },
  {
    degree: '12th HSC',
    institution: 'S.B.N.E. School & Jr. College, Dodi Bk, Sinnar',
    period: '2022 — 2023',
    stream: 'Science',
    detail: 'Percentage: 66.50%',
  },
  {
    degree: '10th SSC',
    institution: 'New English School Manori, Tal Sinnar, Nashik',
    period: '2021 — 2022',
    detail: 'Percentage: 88.80%',
  },
]

const Education = () => {
  return (
    <section id="education" className="scroll-mt-16 bg-slate-50 py-10 dark:bg-slate-950 md:py-12">
      <div className="mx-auto max-w-3xl px-4">
        <div className="reveal">
          <h2 className="text-center text-3xl font-semibold tracking-tight text-slate-900 dark:text-white">
            Education
          </h2>
          <div className="mx-auto mt-3 h-1 w-12 rounded bg-primary" />
        </div>

        <div className="relative mt-8 space-y-0">
          {education.map((item, index) => (
            <div key={item.degree} className={`reveal reveal-delay-${index + 1} relative flex gap-6 pb-8 last:pb-0`}>
              {index < education.length - 1 && <span className="timeline-line" aria-hidden="true" />}

              <div className="relative z-10 mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border-2 border-primary bg-white dark:bg-slate-900">
                <span className="h-2 w-2 rounded-full bg-primary" />
              </div>

              <div className="min-w-0 flex-1 rounded-xl border border-slate-200 bg-slate-50 p-5 transition-shadow hover:shadow-sm dark:border-slate-700 dark:bg-slate-800/50">
                <h3 className="font-semibold text-slate-900 dark:text-white">{item.degree}</h3>
                <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{item.institution}</p>
                {item.stream && (
                  <p className="mt-0.5 text-sm text-slate-500 dark:text-slate-500">{item.stream}</p>
                )}
                <p className="mt-2 text-sm font-medium text-primary">{item.period}</p>
                <p className="mt-1 text-sm text-slate-700 dark:text-slate-300">{item.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Education
